if (!customElements.get('ingredients-slider')) {
  customElements.define(
    'ingredients-slider',
    class IngredientsSlider extends HTMLElement {
      constructor() {
        super();
        this.list = this.querySelector('.ingredients__list');
        this.items = Array.from(this.querySelectorAll('.ingredients__item'));
        this.wrapper = this.closest('.ingredients');

        if (!this.list || this.items.length === 0 || !this.wrapper) return;

        this.prevButtons = Array.from(this.wrapper.querySelectorAll('.ingredients__nav-btn--prev'));
        this.nextButtons = Array.from(this.wrapper.querySelectorAll('.ingredients__nav-btn--next'));

        this.isDown = false;
        this.dragged = false;
        this.startX = 0;
        this.scrollLeftStart = 0;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);

        this.prevButtons.forEach((button) => button.addEventListener('click', () => this.step(-1)));
        this.nextButtons.forEach((button) => button.addEventListener('click', () => this.step(1)));
        this.list.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        this.list.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        this.list.addEventListener('click', this.onClickCapture, true);

        this.updateButtons();
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse') return;
        this.isDown = true;
        this.dragged = false;
        this.startX = event.clientX;
        this.scrollLeftStart = this.list.scrollLeft;
        this.list.classList.add('is-dragging');
      }

      onPointerMove(event) {
        if (!this.isDown) return;
        const delta = event.clientX - this.startX;
        if (Math.abs(delta) > 5) this.dragged = true;
        this.list.scrollLeft = this.scrollLeftStart - delta;
      }

      onPointerUp() {
        if (!this.isDown) return;
        this.isDown = false;
        this.list.classList.remove('is-dragging');
        requestAnimationFrame(() => {
          this.dragged = false;
        });
      }

      onClickCapture(event) {
        if (this.dragged) {
          event.preventDefault();
          event.stopPropagation();
        }
      }

      step(direction) {
        const itemRect = this.items[0].getBoundingClientRect();
        const gap = parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap) || 0;
        this.list.scrollBy({ left: direction * (itemRect.width + gap), behavior: 'smooth' });
      }

      onScroll() {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = window.setTimeout(() => this.updateButtons(), 100);
      }

      updateButtons() {
        const maxScroll = this.list.scrollWidth - this.list.clientWidth - 1;
        const atStart = this.list.scrollLeft <= 0;
        const atEnd = this.list.scrollLeft >= maxScroll;

        this.prevButtons.forEach((button) => (button.disabled = atStart));
        this.nextButtons.forEach((button) => (button.disabled = atEnd));
      }
    }
  );
}
